<template>
  <div class="sqs">
    <el-button @click="handleUpload">下载授权书</el-button>
    <el-button @click="handleSend"
               :loading="loading"
               type="primary">发送授权书
    </el-button>
    <div class="content">
      <canvas id="canvas"
              width="1000"
              height="1365"></canvas>
    </div>
    <auth ref="auth"
          @submit="getList">
    </auth>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        canvas: '',
        form: {
          qq: 'qq',
          id: '公司编号',
          date: '公司日期',
          name: '这是公司名称'
        },
        color: '#000',
        size: '26px',
        font: '黑体',
      }
    },
    created() {

    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.canvas = document.getElementById("canvas");
        const canvas = this.canvas;
        const context = canvas.getContext("2d");
        const seal = new Image();
        seal.src = "./images/seal.png";
        const beauty = new Image();
        if (this.form.version === "5") {
          beauty.src = "./images/sqstemp1.png";
        } else if (this.form.version === "6") {
          beauty.src = "./images/sqstemp6.png";
        } else if (this.form.version === "7") {
          beauty.src = "./images/sqstemp7.png";
        } else {
          beauty.src = "./images/sqstemp.png";
        }
        beauty.onload = () => {
          const font = 'bold ' + this.size + ' ' + this.font;
          context.drawImage(beauty, 0, 0);

          //绘制公司
          context.fillStyle = this.color;
          context.font = 'bold 29px ' + this.font;
          context.fillText('' + this.form.name + '', 310, 508);

          context.font = font;
          //绘制单位
          context.fillText("上海布雷德科技有限公司", 590, 1162);
          context.stroke();

          //绘制编号
          context.fillText(this.form.id, 590, 1210);
          context.stroke();

          //绘制日期
          context.fillText(this.form.date, 590, 1258);
          context.stroke();

          //绘制公章
          context.drawImage(seal, 620, 1070);
        };
      },
      handleSend() {
        function dataURLtoFile(dataurl, filename) {
          var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          return new File([u8arr], filename, {
            type: mime
          });
        }

        const data = this.canvas.toDataURL('image/jpeg', 1.0);
        const file = dataURLtoFile(data, this.form.name);
        const headers = {"Content-Type": "multipart/form-data"};
        let param = new FormData();
        param.append('file', file, file.name);
        param.append('id', this.form.id);
        param.append('qq', this.form.qq);
        this.loading = true;
        this.$httpajax.post('https://payment.javablade.com/api/license', param, headers).then(resp => {
          if (resp.data.code === 200) {
            this.$message.success('发送成功');
          } else {
            this.$message.success(resp.data.msg);
          }
          this.loading = false;
        }).catch(err => {
          this.loading = false;
          this.$message.error(err.message)
        });
      },
      handleUpload() {
        const contentWidth = this.canvas.width;
        const contentHeight = this.canvas.height;
        const pageHeight = (contentWidth / 592.28) * 841.89;
        let leftHeight = contentHeight;
        let position = 0;
        const imgWidth = 595.28;
        const imgHeight = (592.28 / contentWidth) * contentHeight;
        const pageData = this.canvas.toDataURL('image/jpeg', 1.0);
        const PDF = new window.jsPDF('', 'pt', 'a4');
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              PDF.addPage();
            }
          }
        }
        PDF.save(`(${this.form.id})${this.form.name}.pdf`);
      },
      getList() {
        if (this.$route.query.id) this.form.id = this.$route.query.id;
        if (this.$route.query.date) this.form.date = this.$route.query.date;
        if (this.$route.query.name) this.form.name = this.$route.query.name;
        if (this.$route.query.version) this.form.version = this.$route.query.version;
        if (this.$route.query.qq) this.form.qq = this.$route.query.qq.includes('@')
          ? this.$route.query.qq
          : this.$route.query.qq + '@qq.com';
      }
    }
  }
</script>

<style lang="scss">
  .sqs {
    margin: 0 auto;
    width: 1000px;
    padding: 100px 0;

    .content {
      margin: 40px 0;
    }
  }
</style>
